import { apiCall } from "./service";
import {
  BASE_URL,
  URL_PROJECTS,
  URL_PROGRAM,
  URL_CLIENT,
  URL_COMMUNICATION,
  URL_GET_COMMUNICATION_PLAN,
  URL_CREATE_COMMUNICATION_PLAN,
  URL_UPDATE_COMMUNICATION_PLAN,
  URL_DELETE_COMMUNICATION_PLAN,
  URL_COMMUNICATION_PLAN_FLAG,
  URL_STATUS_REPORT,
  URL_PORTFOLIO,
} from "./URL";

export const api = {
  communicationPlanRequest(params) {
    const { parent, search, id, page, size, isForCalendar, period } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;

    switch (parent) {

      case "Client":
        url = `${BASE_URL}Clients/${id}/CommunicationPlans`;
        break;

      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/CommunicationPlans`;
        break;

      case "Program":
        url = `${BASE_URL}Programs/${id}/CommunicationPlans`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/CommunicationPlans`;
        break;

      default:
        url = `${BASE_URL}CommunicationPlans`;
    }

    if(isForCalendar && period) {
      paginationParams.IsForCalendar = isForCalendar;
      paginationParams.StartDate = period.startDate;
      paginationParams.EndDate = period.endDate;
      paginationParams.Tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    if (!isForCalendar && search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  getcommunicationPlanRequest(params) {
    return apiCall.get({
      url: `${URL_GET_COMMUNICATION_PLAN}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  createCommunicationPlanRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_COMMUNICATION_PLAN}`,
      isAuthToken: true,
      params,
    });
  },

  updateCommunicationPlanRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_COMMUNICATION_PLAN}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  deleteCommunicationPlanRequest(params) {
    return apiCall.delete({
      url: `${URL_DELETE_COMMUNICATION_PLAN}${params}`,
      isAuthToken: true,
      params,
    });
  },
  sortCommunicationPlansRequest(params) {
    if (params.parent === "Communications")
      return apiCall.pagination({
        url: `${BASE_URL}${URL_COMMUNICATION}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Client")
      return apiCall.pagination({
        url: `${URL_CLIENT}${params.id}${URL_COMMUNICATION}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Project")
      return apiCall.pagination({
        url: `${URL_PROJECTS}/${params.id}${URL_COMMUNICATION}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
    if (params.parent === "Program")
      return apiCall.pagination({
        url: `${URL_PROGRAM}/${params.id}${URL_COMMUNICATION}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
    if (params.parent === "Portfolio")
      return apiCall.pagination({
        url: `${URL_PORTFOLIO}/${params.id}${URL_COMMUNICATION}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
  },
  updateCommunicationFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_COMMUNICATION_PLAN_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  }
};

export default api;
